module.exports = __webpack_public_path__ + "static/media/walker.f273253d.svg";